import { Link } from "react-router-dom";
import { ArrowRight, Trophy, Heart } from "lucide-react";
import { MaskedLine, FadeUp } from "@/components/Reveal";

const Journey = () => (
  <main data-testid="journey-page" className="pt-28">
    <section className="mx-auto max-w-7xl px-6 pb-14 pt-10 text-center">
      <MaskedLine delay={0.1}>
        <span className="inline-flex items-center gap-2 rounded-full border border-forest/20 bg-sage/15 px-4 py-1.5 font-display text-[11px] font-bold tracking-[0.25em] text-forest">
          <Trophy className="h-3.5 w-3.5 text-coral" /> MY JOURNEY
        </span>
      </MaskedLine>
      <h1 data-testid="journey-headline" className="mt-6 font-display text-4xl font-black uppercase tracking-tighter text-ink sm:text-5xl md:text-6xl">
        <MaskedLine delay={0.25}>From 192 lbs to</MaskedLine>
        <MaskedLine delay={0.4}>
          <span className="text-coral">the bikini stage 🎉</span>
        </MaskedLine>
      </h1>
    </section>

    <section className="mx-auto max-w-3xl px-6 pb-16">
      <FadeUp>
        <div className="space-y-5 font-body text-base font-light leading-relaxed text-ink/75 md:text-lg">
          <p>
            After the birth of my 3 kids my weight would not come off. I joined Herbalife in the hopes that I would see improvements and I did right away.
          </p>
          <p>
            As I progressed with my Herbalife journey I wanted to challenge myself and see if I could join the Herbalife IPL Bikini contest which required to be fully committed, and would also require for me to go on stage and show my 12-15 week progress. I joined the team and with their guidance and encouragement I was able to achieve my ultimate goal! <span className="font-semibold text-ink">Lost over 50 lbs and ranked 4th in my division!</span> Yay 🎉
          </p>
          <p>
            And so were the other moms who like me had participated and saw amazing weight loss, muscle gain and improvement in their health and everyday eating habits, skin, strength and just overall wellbeing. It was a win win for me and my greatest personal accomplishment and ever since the competition I've been keeping the weight off and been feeling amazing thanks to Herbalife and all the support.
          </p>
          <p className="font-serif text-xl italic text-forest md:text-2xl">
            I hope I can do the same for you, and guide you to a healthier you. ❤️
          </p>
        </div>
      </FadeUp>
    </section>

    <section className="mx-auto max-w-6xl px-6 pb-20">
      <FadeUp className="text-center">
        <p className="font-display text-xs font-bold tracking-[0.3em] text-coral">THE PROOF ❤️</p>
      </FadeUp>
      <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        <FadeUp delay={0.05}>
          <div data-testid="journey-photo-split" className="group overflow-hidden rounded-3xl border border-forest/10 shadow-xl shadow-forest/10">
            <img
              src="/journey-split.jpeg"
              alt="Shelly at 189 lbs with her kids on the beach, and 15 weeks later at 145 lbs on the bikini stage"
              className="w-full transition-transform duration-700 group-hover:scale-[1.02]"
            />
          </div>
          <p className="mt-3 text-center font-serif text-lg italic text-forest/70">15 weeks — 189 lbs to 145 lbs</p>
        </FadeUp>
        <FadeUp delay={0.15}>
          <div data-testid="journey-photo-scale" className="group overflow-hidden rounded-3xl border border-forest/10 shadow-xl shadow-forest/10">
            <img
              src="/transformation.webp"
              alt="Shelly's wellness journey — from 192 lbs to 145 lbs bikini competitor"
              className="w-full transition-transform duration-700 group-hover:scale-[1.02]"
            />
          </div>
          <p className="mt-3 text-center font-serif text-lg italic text-forest/70">192 lbs to 145 lbs — stage ready</p>
        </FadeUp>
        <FadeUp delay={0.25}>
          <div data-testid="journey-photo-stage" className="group overflow-hidden rounded-3xl border border-forest/10 shadow-xl shadow-forest/10">
            <img
              src="/journey-stage.jpeg"
              alt="Shelly on the IPL bikini stage red carpet with her three daughters, competitor number 15"
              className="w-full transition-transform duration-700 group-hover:scale-[1.02]"
            />
          </div>
          <p className="mt-3 text-center font-serif text-lg italic text-forest/70">Stage day with my biggest fans ❤️</p>
        </FadeUp>
      </div>
      <FadeUp className="mt-10 text-center">
        <p className="font-body text-xs font-light text-ink/45">Personal story — individual results vary.</p>
      </FadeUp>
    </section>

    <section className="grain relative overflow-hidden bg-forest px-6 py-24 text-center">
      <FadeUp>
        <Heart className="mx-auto h-10 w-10 fill-coral text-coral" />
        <h2 data-testid="journey-cta-headline" className="mt-6 font-display text-4xl font-black uppercase tracking-tight text-bone md:text-5xl">
          Your journey starts today
        </h2>
        <p className="mx-auto mt-4 max-w-md font-body text-base font-light leading-relaxed text-bone/75 md:text-lg">
          If I can do it, so can you — and I'd love to guide you.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/get-started"
            data-testid="journey-get-started-button"
            className="group inline-flex items-center gap-2 rounded-full bg-coral px-10 py-5 font-display text-sm font-bold tracking-[0.15em] text-bone transition-all duration-300 hover:scale-105 hover:bg-coraldark"
          >
            GET STARTED
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <Link
            to="/get-started#contact"
            data-testid="journey-contact-button"
            className="inline-flex items-center gap-2 rounded-full border border-bone/30 px-10 py-5 font-display text-sm font-bold tracking-[0.15em] text-bone transition-all duration-300 hover:scale-105 hover:border-coral hover:text-coral"
          >
            TALK TO ME ❤️
          </Link>
        </div>
      </FadeUp>
    </section>
  </main>
);

export default Journey;
